const upperFirst = (input: string) => `${input.charAt(0).toLocaleUpperCase()}${input.substr(1)}`

export default upperFirst
